module.exports = "<div class=\"loans-detail-minimum-fee\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <button type=\"button\" class=\"btn btn-app btn-primary\" ng-click=\"$ctrl.onClick()\">{{ $ctrl.loan.detail.minimumFee | translate }}</button>\n  <p class=\"minimum-fee\"\n     ng-if=\"$ctrl.minimumFee !== undefined\">\n    {{ $ctrl.loan.detail.minimumFeeResult | translate }} = <span>{{ $ctrl.minimumFee | currency }}</span>\n  </p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansDetail/loansDetailMinimumFee/loansDetailMinimumFee.html
// module id = 1849
// module chunks = 0